var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSensor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "20px",
    viewBox: "0 -960 960 960",
    width: "20px",
    fill: "#FFFFFF",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M168-480.47Q168-425 186-376t50 89q10 12 9.5 26.5t-11.26 25.46q-10.76 11.04-26 10.54T183-237q-42-50-64.5-112T96-480.09q0-69.09 22.5-130.5T182-723q10-12 25-13t26 10q11 11 11 25.39 0 14.4-9 26.61-32 41-49.5 90.03T168-480.47Zm144 .62q0 25.85 7.04 48.78Q326.09-408.14 339-388q8 13 8 27t-10.76 24.96q-10.76 11.04-26 10.54T286-338q-22-30-34-66t-12-76q0-39.84 12.02-76.11Q264.05-592.37 286-622q9-12 24-13t26 10q11 11 11 25.5t-8 27.5q-12.91 20.23-19.96 43.27Q312-505.7 312-479.85ZM479.75-396q-34.75 0-59.25-24.75t-24.5-59.5q0-34.75 24.75-59.25t59.5-24.5q34.75 0 59.25 24.75t24.5 59.5q0 34.75-24.75 59.25t-59.5 24.5ZM648-480.15q0-25.85-7.04-48.78Q633.91-551.86 621-572q-8-13-7.5-27t11.43-24.96q10.93-11.04 25.5-10.54T674-622q21.95 29.63 33.98 65.89Q720-519.84 720-480q0 40-12.55 76.71Q694.91-366.57 672-337q-9 11-23 11.5T624-336q-11-11-11-25t8-27q12.91-20.23 19.96-43.27Q648-454.3 648-480.15Zm144 .62Q792-535 774.5-584T725-674q-9-12-9-27t11-26q11-11 26-9.5t25 13.5q41 51 63.5 112.41t22.5 130.5Q864-411 841.5-349T777-237q-10 12-25.53 12.5-15.54.5-26.5-10.32Q714-245.54 714-260.27 714-275 724-287q32-40 50-89.03t18-103.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSensor);
export default __webpack_public_path__ + "static/media/sensor.164fd669e9e33c2fd170cfaebd855192.svg";
export { ForwardRef as ReactComponent };